<div class="flex items-center justify-center dialog-header ">
    Upload Documents

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div class="p-4 flex justify-center items-center">
        <div class="p-6 rounded-lg shadow-lg w-full">

            <div class="flex items-center justify-between mb-4 flex-col md:flex-row">

                <div class="lg:max-w-[300px] w-full">
                    <label class="block font-semibold mb-2">Document Category</label>
                    <p-select 
                    appendTo="body"
                    [options]="documents" [(ngModel)]="selectedCategory" placeholder="Select"
                        class="w-full mb-4"></p-select>
                </div>

                <div class="flex justify-between items-center flex-col gap-2">
                    <p-fileUpload 
                    #fileUpload
                    mode="basic" [disabled]="!selectedCategory" [multiple]="true" name="file"
                        accept=".png,.jpg,.jpeg,.pdf" [maxFileSize]="104857600" (onSelect)="onFileSelect($event)"
                        [auto]="true" chooseLabel="Choose File"></p-fileUpload>
                    <p class="text-sm text-gray-500 ">File size can be max to 100MB in Png, Jpeg, and PDF</p>
                </div>
            </div>

            <div *ngIf="isUploading" class="flex items-center justify-center mt-10 flex-col">
                <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>

                <div class="mt-4">
                    <p>Uploading...</p>
                </div>
            </div>

            <div class="mt-4 space-y-2" *ngIf="!isUploading">
                <div *ngFor="let file of uploadedFiles; let i = index"
                    class="flex items-center justify-between border p-4 rounded-md bg-gray-50">
                    <!-- <div class="flex items-center space-x-2">
                        <img src="assets/pdf-icon.png" alt="PDF" class="w-6 h-6" *ngIf="file.type === 'pdf'" />
                        <img [src]="file.document_url" alt="Preview" class="w-10 h-10 object-cover rounded"
                            *ngIf="file.type === 'image'" />
                        <span class="text-gray-700">{{ file.document_name }}</span>
                    </div> -->
                    <span class="text-gray-700">{{ file.document_name }}</span>
                    <button (click)="removeFile(i)" class="text-red-500 hover:text-red-700">
                        ✖
                    </button>
                </div>
            </div>

            <div class="flex justify-end w-full mt-5">
                <!-- <p-button class="flex justify-end" icon="pi pi-upload" (click)="submitFiles()">
                    Upload
                </p-button> -->
                <p-button [label]="'Upload'"
                icon='pi pi-save' [disabled]="isLoading || !uploadedFiles.length"
                [loading]="isLoading" (click)="submitFiles()"
                class="w-full md:w-auto"></p-button>
            </div>
        </div>
    </div>

</div>